import React from 'react';
import type { JournalPromptsPayload } from '../../../data-access/api/science/openapi/api';
import './richContext.scss';

type Props = {
  p: JournalPromptsPayload;
};

const JournalPromptsContent: React.FC<Props> = ({ p }) => {
  return (
    <div className="rc-content-body">
      {!!p.label && <span className="rc-content-label">{p.label}</span>}
      {p.prompts.map((prompt, i) => (
        <div key={i} className="rc-list-row">
          <span className="rc-list-bullet">{i + 1}.</span>
          <span className="rc-list-text">{prompt}</span>
        </div>
      ))}
    </div>
  );
};

export default JournalPromptsContent;
